export default [
    {
        name: '2022 Offseason',
        trades: [
            {
                Tench: ['DJ Moore', 'Mike 2024 3rd'],
                Mike: ['Jamaal Williams', 'Deandre Swift']
            },
            {
                Tench: ['Michael Thomas', 'Davis 2024 2nd', 'Trey Lance'],
                Davis: ['Tench 2022 1st', 'Tench 2022 6th']
            },
            {
                Tench: ['Zane 2023 1st', 'Zane 2024 3rd', 'Davis 2024 3rd', 'Allen Lazard'],
                Zane: ['Mike 2022 1st', 'Tench 2023 5th', 'Tench 2023 6th', 'Tench 2023 7th']
            },
            {
                Mike: ['Kyle Pitts', 'Tench 2022 2nd'],
                Davis: ['TJ Hockenson', 'Mike 2022 1st', 'Mike 2022 3rd']
            },
            {
                Davis: ['James Conner', 'Michael Thomas', 'Scott 2022 2nd', 'Lamar Jackson'],
                Scott: ['Joe Mixon', 'Taylor 2022 2nd', 'Josh Allen', 'DJ Chark']
            },
            {
                Aidan: ['Mike 2022 6th'],
                Mike: ['TJ Hockenson']
            },
            {
                Mike: ['Dan 2022 1st', 'Tench 2022 5th', 'Tench 2022 7th'],
                Tench: ['George Kittle', 'Mike 2022 4th']
            }
        ]
    },
    {
        name: '2021 Season',
        trades: [
            {
                Aidan: ['Marquise Brown'],
                Mike: ['Aidan 2022 4th']
            },
            {
                Kieffer: ['Mike Williams'],
                Scott: ['Kieffer 2022 3rd']
            },
            {
                Mike: ['Calvin Ridley'],
                Tench: ['Mike 2022 1st', 'Mike 2023 1st', 'Mike 2023 3rd']
            },
            {
                Tench: ['Devin Singletary'],
                Steve: ['Tommy 2022 3rd', 'Tench 2023 4th', 'Tench 2022 6th']
            },
            {
                Scott: ['Quintez Cephus'],
                Zane: ['Chuba Hubbard', 'Scott 2022 3rd', 'Scott 2022 4th']
            },
            {
                Davis: ['Chris Evans', 'Tench 2022 2nd'],
                Tench: ['Zach Moss', 'Davis 2022 6th']
            },
            {
                Aidan: ['Damian Williams'],
                Tench: ['Aidan 2022 4th']
            },
            {
                Zane: ['Tench 2022 2nd', 'Tench 2022 3rd', 'Aidan 2022 4th'],
                Tench: ['Henry Ruggs III']
            },
            {
                Mike: ['Dan 2022 3rd'],
                Tench: ['TJ Hockenson']
            },
            {
                Davis: ['Antonio Brown'],
                Zane: ['Davis 2023 2nd', 'Davis 2024 3rd', 'Elijah Moore']
            },
            {
                Davis: ['$90 FAAB 2021'],
                Mike: ['Kahlil Herbert']
            },
            {
                Aidan: ['Devonta Booker', '$100 FAAB 2022', '$100 FAAB 2023'],
                Zane: ['Aidan 2022 3rd', 'Aidan 2023 2nd']
            },
            {
                Tench: ['Aidan 2023 4th', '$50 FAAB 2022', '$25 FAAB 2023'],
                Aidan: ['TJ Hockenson', 'Jeremy McNichols']
            },
            {
                Mike: ['Scott 2022 1st', 'Scott 2023 2nd', 'Trey Sermon'],
                Scott: ['Ezekiel Elliot', 'Amari Cooper']
            },
            {
                Davis: ['Christian McCaffery, Taylor 2022 2nd'],
                Taylor: ['Davis 2023 1st', 'Deandre Hopkins']
            },
            {
                Conor: ['Adam Theilen'],
                Kieffer: ['Conor 2022 3rd', 'Zane 2022 4th']
            },
            {
                Kieffer: ['Zane 2022 3rd', 'Aidan 2022 6th'],
                Aidan: ['Darrell Henderson']
            },
            {
                Scott: ['Nick Chubb', 'Tyreek Hill', 'Scott 2022 2nd'],
                Mike: ['Derrick Henry', 'Jarvis Landry']
            }
        ]
    },
    {
        name: '2021 Draft Day',
        trades: [
            {
                Tench: ['Pick 31', 'Tench 2022 3rd', 'Tyler Boyd', 'Devante Parker'],
                Tommy: ['Pick 14']
            },
            {
                Davis: ['Pick 16', 'Pick 29'],
                Tommy: ['Jerry Jeudy', 'Mike Davis', 'Aidan 2022 2nd', 'Davis 2023 3rd']
            },
            {
                Davis: ['Pick 6', 'Pick 43'],
                Steve: ['Pick 16', 'Pick 31', 'Pick 32']
            },
            {
                Scott: ['Pick 17'],
                Mike: ['Pick 34', 'Scott 2022 2nd']
            },
            {
                Tommy: ['Pick 29'],
                Tench: ['Tench 2022 3rd']
            },
            {
                Conor: ['Davis 2022 2nd'],
                Tommy: ['Pick 18']
            },
            {
                Steve: ['Pick 42', 'Pick 51'],
                Zane: ['Pick 31']
            },
            {
                Steve: ['Pick 61', 'Mike 2022 5th'],
                Mike: ['Pick 51']
            },
            {
                Mike: ['Pick 75'],
                Zane: ['Mike 2022 7th', 'Mike 2023 7th']
            }
        ]
    },
    {
        name: '2021 Offseason',
        trades: [
            {
                Tench: ['Zane 2023 3rd'],
                Zane: ['Tench 2021 4th', 'Tench 2021 5th']
            },
            {
                Tench: ['Zane 2023 5th'],
                Zane: ['Tench 2021 6th', 'Tench 2021 7th']
            },
            {
                Tench: ['Mike 2021 1st'],
                Mike: ['Nick Chubb', 'Tench 2021 2nd', 'Mike 2021 4th']
            }, 
            {
                Tench: ['Steve 2022 2nd'],
                Steve: ['Tench 2021 3rd', 'Scott 2021 3rd']
            },
            {
                Tench: ['Davis 2026 7th'],
                Davis: ['Tench back in the main group chat']
            },
            {
                Tench: ['Conor 2021 1st'],
                Zane: ['Conor 2021 2nd', 'Davis 2021 2nd', 'Tench 2022 4th']
            },
            {
                Scott: ['Mike Evans'],
                Kieffer: ['Aidan 2021 2nd', 'Tommy 2021 3rd']
            },
            {
                Davis: ['DJ Chark'],
                Tommy: ['Todd Gurley II', 'Scott 2021 4th', 'Davis 2022 5th']
            },
            {
                Tommy: ['Mike 2021 2nd', 'Tommy 2021 2nd'],
                Davis: ['Tommy 2021 1st']
            },
            {
                Tench: ['Calvin Ridley', 'Dan 2022 1st', 'Dan 2022 3rd', 'Dan 2023 2nd'],
                Dan: ['Mike 2021 1st']
            },
            {
                Mike: ['Tench 2021 1st', 'Conor 2021 1st'],
                Tench: ['Clyde Edwards-Helaire', 'Davis 2021 3rd round']
            },
            {
                Davis: ['Mike Davis'],
                Zane: ['Steve 2021 4th']
            }
        ]
    },
    {
        name: '2020 Season',
        trades: []
    },
    {
        name: '2019 Season',
        trades: [
            {
                Davis:['Conor 2019 1st','Mike 2019 1st ','Conor 2019 2nd'],
                Conor: ['Joe Mixon', 'Zane 2021 1st', 'Mike 2019 2nd']
            },
            {
                Davis:['Scott 2019 1st (via Conor)','Davis 2019 3rd (via Mike)','Michael 2020 5th (via Mike)','Michael 2021 2nd (via Mike)'],
                Conor: ['Odell Beckham (via Mike)','Robert Woods (via Davis)'],
                Mike: ['Davis 2019 1st (via Conor)', 'Conor 2019 2nd (via Davis)']
            },
            {
                Tom:['16th Pick','23rd Pick'],
                Alex: ['9th Pick']
            },
            {
                Alex:['Steve 2020 2nd'],
                Steve: ['2019 3rd','3 X 2019 4th']
            },
            {
                Davis:['2019 2nd '],
                Aidan: ['Patrick Mahomes','2019 5th']
            },
            {
                Conor:['2019 16th'],
                Tom: ['2019 23','2019 35']
            },
            {
                Tench:['Chris Carson','2020 2nd ','2020 3rd'],
                Bay: ['2019 3rd overall']
            },
            {
                Tommy:['2019 6th','M. Valdes- Scantling'],
                Tench: ['Brandin Cooks']
            },
            {
                Conor:['2019 19th','2021 Kieffer','2021 Davis'],
                Davis: ['OBJ','2019 14th','2019 16th']
            },
            {
                Tom:['Mike Williams','2019 7th','2019 26th'],
                Davis: ['Adam Thielen','2019 23rd']
            },
            {
                Steve:['Melvin Gordon','Austin Ekeler'],
                Scott: ['Alvin Kamara','2019 Kieffer 3rd Round','2020 Steve 5th ','2021 Davis 2nd Round ']
            },
            {
                Aidan:['2019 6th overall','2019 2nd','2020 2nd','2022 2nd'],
                Tommy: ['Sony Michell','2019 4th','2020 4th']
            },
            {
                Michael:['Alvin Kamara','Keenan Allen'],
                Scott: ['Travis Kelce','DeAndre Hopkins','2019 2nd']
            },
            {
                Scott:['Carlos Hyde'],
                Tench: ['Devante Parker','Steve 2020 5th round']
            },
            {
                Steve:['Darren Waller'],
                Davis: ['Steve 2020 7th','Steve 2021 6th']
            },
            {
                Kieffer:['K. Ballage','A. Peterson'],
                Scott: ['T. Montgomery','2021 3rd Rounder']
            },
            {
                Mike:['Antonio Brown'],
                Taylor: ['Josh Jacobs']
            },
            {
                Scott:['Adam Thielen'],
                Davis: ['2020 5th','Davis 2021 2nd','R Higgins']
            },
            {
                Mike:['Tarik Cohen','Davis 2020 1st','Tommy 2020 2nd'],
                Aidan: ['Alvin Kamara']
            },
            {
                Aidan:['Odell Beckham','2020 7th'],
                Davis: ['2021 1st','2020 2nd','2020 4th','2021 3rd']
            },
            {
                Scott:['Devonta Freeman'],
                Tench: ['2020 3rd']
            },
            {
                Davis:['Robert Woods','Davis 2020 2nd','Davis 2021 1st'],
                Conor: ['Leonard Fournette','Aidan 2021 3rd']
            },
            
            


            
            


            
            


            
            


            
            


            
            


            
            


            
            


            
            


            
            


            
            


            
            


            
            


            
            


            
            


            
            


            
            


            
            


            
            


            
            


            
            


            




        ]

    }
]